<template>
  <div>
    <div v-if="fromTimeLineInfo">
      <OpportunityMeetingCard
        :id="id"
        :eventCalendly="event || {}"
        :meeting_id="meeting_id"
        @open-modal-mod-meet="$emit('open-modal-mod-meet', $event)"
      />
    </div>
    <div class="contact-info" v-else>
      <span
        v-if="loading"
        class="loadingres mr-2 ml-2 spinner-border loading-spinner"
      ></span>
      <div v-if="event && event.name !== undefined">
        <img
          v-if="event.data !== undefined && event.data.provider == 'gmail'"
          class="mx-auto"
          width="15px"
          src="@/assets/images/gmail.png"
          alt
        />
        <img
          v-if="event.data !== undefined && event.data.provider == 'ews'"
          class="mx-auto"
          width="40px"
          src="@/assets/images/outlook-calendar.png"
          alt
        />
  
        <Info
          v-if="new Date(event.start_time) < new Date()"
          :message="$t('lang.appointments.expired')"
          :color="'danger'"
        ></Info>
        <Info
          :message="$t('lang.calendar.reschedule')"
          :color="'primary'"
          v-if="event.reschedule == '1'"
        ></Info>
        <h6>        
          <Tooltip class="float-right text-primary align-middle ml-1" v-if="user.role_id == 1 && event.bdr_manual_assigned != null" :text="$t('lang.opportunities.bdrmanuallyassigned') + ' ('+ event.bdr_manual_assigned +')'" :width="'auto'">
            <i class="icon-info float-right mr-2"></i>
          </Tooltip>
          <button
            v-if="user.role_id == 1"
            class="btn btn-link btn-sm p-0 float-right text-primary align-middle border-primary p-1"
            @click="openModalModifyMeetings()"
          >
            <Tooltip :text="'Assigne une Booker'" :width="'auto'">
              <i class="fa-solid fa-handshake mr-1 p-1"></i>
              <span class="text-primary font-weight-bold" v-if="event.bdr_name_winner != null">{{ event.bdr_name_winner }}</span>
            </Tooltip>
          </button>
          
          <div v-if="isBdrUser || isAdmin">
            <div v-if="event.attendance_status"
            class="float-right text-primary mx-3 mt-1">
              {{  textToAttendanceStatus(event.attendance_status) }}            
              <i 
                class="icon-edit1" 
                :key="'edit-attendance-status-' + event.id"
                style="cursor: pointer;"
                title="Edit attendance status"
                @click="openModalModifyStatusAttendance('statusAttendanceModal')">
              </i>
            </div>
            <button    
              v-else      
              class="btn btn-link btn-sm mx-2 float-right text-primary align-middle border-primary p-1 text-primary font-weight-bold"
              @click="openModalModifyStatusAttendance('statusAttendanceModal')"
            >
              {{ $t("lang.label.set_attendance_status") }}
            </button>
          </div>
          
  
          <span v-show="user.role_id != 4 && user.role_id != 3" v-if="user.role_id != 1" class="float-right text-primary"
            ><b>{{ event.bdr_name_winner }}</b></span
          >
          <i
            class="icon-video-camera mr-2 p-1 text-primary"
            v-if="meetingJoinUrl"
          ></i>
          {{ event.name }}
          <i
            class="icon-circle"
            :class="event.status == 'active' ? 'text-success' : 'text-danger'"
          ></i>
          <small
            v-if="
              event.cancellation !== undefined &&
              event.cancellation.canceler_type !== undefined &&
              event.cancellation.canceler_type == 'host'
            "
            class="badge badge-danger ml-2"
          >
            {{ $t("lang.opportunities.canceledbyclient") }}:
            {{ event.cancellation.canceled_by }}
          </small>
        </h6>
        <div class="">
          <strong
            :class="
              new Date(event.start_time) < new Date()
                ? 'text-danger'
                : 'text-primary'
            "
          >
            <i class="icon-calendar mr-1"></i>
            <span v-if="!editingDate">{{ event.start_time }}</span>
          </strong>
          <date-picker
            v-if="editingDate"
            id="endDatePicker"
            style="width: 250px; position: relative"
            class="d-inline p-0 ml-2 text-center w-auto"
            v-model="event.start_time"
            :config="datePickerConfigEndDate"
            placeholder="Event Date"
          ></date-picker>
  
          <strong
            class="text-secondary ml-1"
            v-if="
              event.timezone !== undefined &&
              event.timezone !== '' &&
              event.timezone !== null
            "
            >({{ event.timezone.zone_name }})</strong
          >
          <div class="d-inline">
            <strong
              v-if="
                false &&
                !loadingediting &&
                !editingDate &&
                event.calendar_event == undefined
              "
              @click="openEdit()"
            >
              <i
                class="icon-pencil ml-1 text-white bg-primary p-1 rounded-circle"
              ></i>
            </strong>
            <span
              v-if="loadingediting"
              class="loadingres mr-2 ml-2 spinner-border loading-spinner"
            ></span>
  
            <span
              class="btn btn-sm btn-primary ml-1"
              v-if="editingDate"
              @click="changeEventDate(event.start_time)"
            >
              {{ $t("lang.label.edit") }}
            </span>
          </div>
          <div>
            <small v-if="editingDate" class="text-danger"
              >Warning<i class="icon-warning text-warning"></i>:
              {{ $t("lang.calendar.modifyeventrisk") }}</small
            >
          </div>
        </div>
        <template v-if="event.location">
          <div
            v-if="meetingJoinUrl"
            class="my-2"
          >
            <h6 class="mt-2">{{ $t("lang.label.joinTheMeeting") }}</h6>
            <a
              :href="meetingJoinUrl"
              target="_blank"
              class="text-primary d-block ml-3"
            >
              <small
                ><i class="icon-video-camera mr-2"></i>
                {{ meetingJoinUrl }}</small
              >
            </a>
          </div>
          <div v-if="event.error_conference != null" class="row ml-1 mt-1 rounded-pill">
            <i class="icon icon-warning text-warning mt-1"></i>
            <h6 class="ml-1 text-warning">{{ event.error_conference }}</h6>
          </div>
        </template>
        <template v-if="event.invitees">
          <div
            v-if="false"
            v-for="question in event.invitees[0].questions_and_answers"
          >
            <ul>
              <li v-if="['Entreprise', 'Téléphone'].includes(question.question)">
                <small>
                  <strong>{{ question.question }}:</strong> {{ question.answer }}
                </small>
              </li>
            </ul>
          </div>
        </template>
        <div v-if="event.invitees !== undefined">
          <h6 class="mt-2">{{ $t("lang.appointments.participants") }}</h6>
          <div v-for="invitee in event.invitees">
            <h5>
              <small>
                <Tooltip
                  class="ml-2 text-primary"
                  :text="textToStatusInvitee(invitee)"
                  :width="'auto'"
                >
                  <i class="icon-circle" :class="getStatusInvitee(invitee)"></i>
                </Tooltip>
                {{ invitee.name }} {{ invitee.email }}</small
              >
            </h5>
          </div>
        </div>
  
        <div v-if="event.invitees !== undefined" class="">
          <div
            class="ml-3"
            v-for="question in event.invitees[0].questions_and_answers"
          >
            <ul>
              <li>
                <small>
                  <strong>{{ question.question }}:</strong> {{ question.answer }}
                </small>
              </li>
            </ul>
          </div>
        </div>
  
        <div
          v-if="event.location && !meetingJoinUrl"
          class="mt-2"
        >
          <a
            :href="'tel:' + event.location.location"
            class="bg-primary text-white p-1 rounded ml-3 px-2"
          >
            <i class="icon-phone mr-2"></i
            ><small v-if="event.location.location">{{
              phoneWithSpaces(event.location.location)
            }}</small>
          </a>
        </div>
        <div v-if="event.business_contact_data" class="opp card p-2 mt-3">
          <div class="mt-1">
            <div class="mb-2">{{ $t("lang.column.contacted_person") }}:</div>
            <div class="d-flex">
              <strong
                >{{ event.business_contact_data.first_name }}
                {{ event.business_contact_data.last_name }}</strong
              >
              <a
                v-if="event.business_contact_data.linkedinurl"
                class="ml-2"
                :href="event.business_contact_data.linkedinurl"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i class="icon-linkedin color-ln"></i>
              </a>
            </div>
            <div v-if="event.business_contact_data.job">
              <small>{{ replaceChain(event.business_contact_data.job) }}</small>
            </div>
            <div>
              <small class="font-weight-bold text-primary">{{
                event.business_contact_data.email
              }}</small>
            </div>
          </div>
        </div>
        <div class="mt-4 float-left">
          <small
            >{{ $t("lang.column.creationdate") }}: {{ event.created_at }}
          </small>
        </div>
  
        <div class="container mt-5" v-if="rescreate && rescreate.result">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">{{ rescreate.result.title }}</h5>
              <p class="card-text" v-html="rescreate.result.description"></p>
              <p><strong>Status:</strong> {{ rescreate.result.status }}</p>
              <p><strong>Start Time:</strong> {{ start_time }}</p>
              <p><strong>End Time:</strong>{{ end_time }}</p>
              <p>
                <strong>Organizer:</strong> {{ rescreate.result.organizer_name }}
              </p>
              <p>
                <strong>Organizer Email:</strong>
                {{ rescreate.result.organizer_email }}
              </p>
              <p>
                <strong>Meeting URL:</strong>
                <a
                  :href="rescreate.result.conferencing.details.url"
                  target="_blank"
                  >{{ rescreate.result.conferencing.details.url }}</a
                >
              </p>
              <p><strong>Participants:</strong></p>
              <ul>
                <li v-for="participant in rescreate.result.participants">
                  {{ participant.email }} ({{ participant.status }})
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="row float-left">
          <div class="badge badge-danger">
            <strong v-if="rescreate && !rescreate.result">{{ rescreate }}</strong>
          </div>
          <div class="col-12">
            <button
              :disabled="
                loadingcreate || eventCalendly.data.activated_spark != '1'
              "
              class="btn btn-sm btn-primary mt-4"
              @click="createEvent(eventCalendly)"
              v-if="eventCalendly && !rescreate && eventCalendly.notsync == '1'"
            >
              <i class="icon-send"></i> Create event
              <span
                class="loadingres mr-2 ml-2 spinner-border loading-spinner"
                v-if="loadingcreate"
              ></span>
            </button>
          </div>
          <div class="col-12">
            <button
              :disabled="
                loadingcreate ||
                eventCalendly.data.activated_spark == '1' ||
                eventCalendly.data.activated == '1'
              "
              class="btn btn-sm btn-primary mt-1"
              @click="createEvent(eventCalendly)"
              v-if="eventCalendly && !rescreate && eventCalendly.notsync == '1'"
            >
              <i class="icon-send"></i> Create event using prospector
              <span
                class="loadingres mr-2 ml-2 spinner-border loading-spinner"
                v-if="loadingcreate"
              ></span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <modal 
      :resizable="false" 
      :scrollable="false" 
      :max-width="400" 
      height="auto" 
      :size="'440px'" 
      style="z-index: 10"
      class="modal-preview p-4" 
      name="statusAttendanceModal"
      @before-open="onModalBeforeOpen"
      @opened="onModalOpened">
      <div class="p-4">
        <h5 class="mb-4">{{ $t("lang.label.set_attendance_status") }}</h5>
        <div class="form-group">
          <label for="attendanceStatusSelect">{{ $t("lang.label.attendance_status") }}</label>
          <select 
            id="attendanceStatusSelect"
            class="form-control" 
            v-model="selectedAttendanceStatus"
          >
            <option value="">{{ $t("lang.label.select_a_status") }}</option>
            <option value="confirmed_attendance">{{ $t("lang.label.confirmed_attendance") }}</option>
            <option value="rescheduled_meeting">{{ $t("lang.label.rescheduled_meeting") }}</option>
            <option value="cancelled_meeting">{{ $t("lang.label.cancelled_meeting") }}</option>
            <option value="unable_to_reach">{{ $t("lang.label.unable_to_reach") }}</option>
            <option value="undefined_meeting">{{ $t("lang.label.undefined_meeting") }}</option>
          </select>
        </div>
        <div class="d-flex justify-content-end mt-3">
          <button 
            class="btn btn-secondary mr-2" 
            @click="closeAttendanceModal"
            :disabled="loadingAttendanceStatus"
          >
            {{ $t("lang.button.cancel") }}
          </button>
          <button 
            class="btn btn-primary" 
            @click="saveAttendanceStatus"
            :disabled="!selectedAttendanceStatus || loadingAttendanceStatus"
          >
            <span
              v-if="loadingAttendanceStatus"
              class="spinner-border spinner-border-sm mr-2"
            ></span>
            {{ $t("lang.button.save") }}
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { calendlyService, clientsService, linksService } from "@/_services";
import moment from "moment";
import { mapState, mapActions } from "vuex";
import Tooltip from "@/components/Common/Tooltip.vue";
import OpportunityMeetingCard from "@/components/Opportunities/OpportunityMeetingCard.vue";
import Modal from "@/components/Common/Modal.vue";
import Info from "@/components/Common/Info.vue";

export default {
  components: { Tooltip, Info, Modal, OpportunityMeetingCard },
  data() {
    return {
      eventdata: false,
      prev_start_time: false,
      loadingediting: false,
      start_time: "",
      end_time: "",
      loadingcreate: false,
      rescreate: false,
      event: false,
      loading: true,
      datePickerConfigEndDate: {
        format: "YYYY-MM-DD H:mm",
        useCurrent: false,
        minDate: moment().endOf("day"),
      },
      editingDate: false,
      selectedAttendanceStatus: "",
      loadingAttendanceStatus: false,
      modalMeetingId: null,
    };
  },
  props: {
    id: String,
    eventCalendly: Object,
    meeting_id: String,
    fromTimeLineInfo: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    if(this.fromTimeLineInfo){
      return;
    }
    if (this.id == undefined) {
      this.event = this.eventCalendly;
      this.loading = false;
    } else {
      this.getEvent();
    }
  },
  computed: {
    textToAttendanceStatus() {
      return (attendanceStatus) => {       
        
        switch (attendanceStatus) {
          case "confirmed_attendance":
            return this.$t("lang.label.confirmed_attendance");
          case "rescheduled_meeting":
            return this.$t("lang.label.rescheduled_meeting");
          case "cancelled_meeting":
            return this.$t("lang.label.cancelled_meeting");
          case "unable_to_reach":
            return this.$t("lang.label.unable_to_reach");
          case "undefined_meeting":
            return this.$t("lang.label.undefined_meeting");
          default:
            return "";
        }        
      };
    },
    user() {
      return this.$store.state.authentication.user;
    },
    ...mapState({
      opportunity: (state) => state.opportunities.selected.data,
      user: (state) => state.authentication.user,
    }),
    textToStatusInvitee() {
      return (invitee) => {
        if (!invitee.status == undefined) {
          return "";
        }
        if (invitee.status == "canceled" || invitee.status == "cancelled") {
          return this.$t("lang.opportunities.meeting_cancelled");
        }
        if (invitee.status == "confirmed" || invitee.status == "active") {
          return this.$t("lang.opportunities.invite_accepted");
        }
        if (invitee.status == "maybe") {
          return this.$t("lang.opportunities.invite_pending");
        }
        return "";
      };
    },
    meetingJoinUrl() {
      if (!this.event || !this.event.location) return "";
      const url = this.event.location.join_url;
      if (url === undefined || url === null) return "";
      return String(url).trim();
    },
    isBdrUser() {
      return (this.user.booker) ? true : false;     
    },    
    isAdmin() {
      return (this.user.role_id == 1) ? true : false;     
    },    
    phoneWithSpaces() {
      return (value) => {
        let phone = "";
        if (value !== null && value.length > 0) {
          value
            .replace(/\s+/g, "")
            .split("")
            .forEach((digit, i) => {
              if (i % 2) {
                phone += digit;
              } else {
                phone += " " + digit;
              }
            });
          phone = "+" + phone;
        }
        return phone;
      };
    },
  },
  methods: {
    openModalModifyMeetings() {
      this.$emit('open-modal-mod-meet', {
        meetingId: this.meeting_id,
        bdrTaskName: this.event.bdr_name_winner,
        bdrTaskId: this.event.bdr_notification_id
      });
    },
    onModalBeforeOpen(event) {
      // Este evento se dispara cuando el modal se va a abrir
      // Guardar el meeting_id en el evento del modal para que esté disponible cuando se guarde
      const meetingId = this.meeting_id || this.id || null;
      if (meetingId) {
        // Almacenar el meeting_id en el evento del modal
        event.params = event.params || {};
        event.params.meetingId = meetingId;
        // Guardar el meeting_id en el almacenamiento del modal (compartido entre todas las instancias)
        // Usar el nombre del modal como clave para almacenar el meeting_id
        if (!window.modalMeetingIds) {
          window.modalMeetingIds = {};
        }
        window.modalMeetingIds['statusAttendanceModal'] = meetingId;
        // También guardarlo en una variable de instancia para acceso directo
        this.modalMeetingId = meetingId;
        console.log("onModalBeforeOpen - meeting_id guardado:", meetingId);
      }
    },
    onModalOpened(event) {
      // Cuando el modal se abre, guardar el meeting_id desde los parámetros o el almacenamiento
      let meetingId = null;
      if (event && event.params && event.params.meetingId) {
        meetingId = event.params.meetingId;
      } else if (window.modalMeetingIds && window.modalMeetingIds['statusAttendanceModal']) {
        meetingId = window.modalMeetingIds['statusAttendanceModal'];
      }
      if (meetingId) {
        this.modalMeetingId = meetingId;
        console.log("onModalOpened - meeting_id desde params/storage:", meetingId);
      }
    },
    openModalModifyStatusAttendance(name) {
      // Guardar el meeting_id actual en una variable específica del modal
      // Intentar obtener el ID desde múltiples fuentes
      const meetingId = this.meeting_id || this.id || null;
      this.modalMeetingId = meetingId;
      
      // Guardar el meeting_id en el almacenamiento del modal (compartido entre todas las instancias)
      if (!window.modalMeetingIds) {
        window.modalMeetingIds = {};
      }
      if (meetingId) {
        window.modalMeetingIds['statusAttendanceModal'] = meetingId;
      }            
      this.selectedAttendanceStatus = "";
      // Pasar el meeting_id como parámetro al abrir el modal
      this.$modal.show(name, { meetingId: meetingId });
    },
    closeAttendanceModal() {
      this.$modal.hide("statusAttendanceModal");
      this.selectedAttendanceStatus = "";
      this.modalMeetingId = null;
      // Limpiar el almacenamiento del modal cuando se cierra
      if (window.modalMeetingIds) {
        delete window.modalMeetingIds['statusAttendanceModal'];
      }
    },
    saveAttendanceStatus() {     
      
      if (!this.selectedAttendanceStatus) {
        this.$swal({
          type: "warning",
          title: "Advertencia",
          text: "Por favor selecciona un estado de asistencia",
          confirmButtonText: "OK",
        });
        return;
      }

      // Usar el meeting_id desde el almacenamiento del modal (compartido entre todas las instancias)
      // Esto asegura que usamos el meeting_id correcto aunque se rendericen otros componentes
      let meetingIdToUse = null;
      
      // Intentar obtener desde el almacenamiento compartido primero
      if (window.modalMeetingIds && window.modalMeetingIds['statusAttendanceModal']) {
        meetingIdToUse = window.modalMeetingIds['statusAttendanceModal'];        
      } else if (this.modalMeetingId) {
        meetingIdToUse = this.modalMeetingId;
      } else {
        // Como último recurso, intentar obtener desde las props
        meetingIdToUse = this.meeting_id || this.id;
      }
      
      if (!meetingIdToUse) {
        console.error("No se encontró meeting_id. Valores disponibles:", {
          meeting_id_prop: this.meeting_id,
          id_prop: this.id,
          modalMeetingId: this.modalMeetingId,
          window_modalMeetingIds: window.modalMeetingIds,
          event: this.event
        });
        this.$swal({
          type: "error",
          title: "Error",
          text: "Meeting ID not found. Check that meeting_id prop is set.",
          confirmButtonText: "OK",
        });
        return;
      }
            
      this.loadingAttendanceStatus = true;
      linksService
        .updateAttendanceStatus(meetingIdToUse, this.selectedAttendanceStatus)
        .then((response) => {
          if (this.event && typeof this.event === "object") {
            this.event.attendance_status = this.selectedAttendanceStatus;
          }
          this.loadingAttendanceStatus = false;
          this.$swal({
            type: "success",
            title: this.$t("lang.taskGeneration.successful"),
            text: this.$t("lang.label.status_saved"),
            confirmButtonText: "OK",
          }).then(() => {
            this.closeAttendanceModal();
          });
        })
        .catch((error) => {
          this.loadingAttendanceStatus = false;
          this.$swal({
            type: "error",
            title: "Error",
            text: error.message || "Error saving attendance status",
            confirmButtonText: "OK",
          });
        });
    },
    ...mapActions("opportunities", {
      setLoadEvent: "setLoadEvent",
    }),
    isReschedule() {
      if (this.event.remark !== null)
        return this.event.remark.includes("NOTSYNC-RESCHEDULE");

      return false;
    },
    createEvent(event) {
      this.rescreate = false;

      let arr = {
        calendar_event_id: event.data.calendar_event_id,
        start_time: event.start_time,
        end_time: event.end_time,
        calendar_client_nylas_id: event.data.calendar_client_nylas_id,
      };
      this.loadingcreate = true;
      clientsService.regenerateEvent(arr).then((res) => {
        this.loadingcreate = false;
        if (res.result == undefined) {
          res.result = res;
        }

        if (!res.result.error) {
          this.rescreate = res;
          this.start_time = new moment.unix(res.result.when.start_time).format(
            "YYYY-MM-DD HH:mm:ss"
          );
          this.end_time = new moment.unix(res.result.when.end_time).format(
            "YYYY-MM-DD HH:mm:ss"
          );
          this.$forceUpdate();
        } else {
          if (res.result.error.message !== undefined) {
            this.rescreate = res.result.error.message;
          }
          if (res.result.error_description !== undefined) {
            this.rescreate = res.result.error_description;
          }
        }
      });
    },
    openEdit() {
      let filters = { event_id: this.event.calendar_event_id };
      this.loadingediting = true;
      clientsService.getAllCalendarNylas(filters).then((result) => {
        this.eventdata = result[0];
        this.prev_start_time = this.eventdata.start_time;
        this.eventdata.invitees = this.event.invitees;
        this.event = this.eventdata;
        this.editingDate = true;
        this.loadingediting = false;
      });
    },
    getEvent() {
      calendlyService.getEvent(this.id, this.meeting_id).then((result) => {
        this.loading = false;
        this.event = result;
        console.log("CalendlyEvent getEvent - event data:", this.event);
        this.event.business_contact_data = this.event.event_type.includes(
          "calendly"
        )
          ? ""
          : JSON.parse(this.event.business_contact_data);

        if (this.opportunity != undefined) {
          this.opportunity.link.event = this.event;
          this.setLoadEvent(true);
        }
      });
    },
    replaceChain(chain) {
      if (chain != null) {
        var search = "&amp;";
        var str = chain;
        str = str.replace(new RegExp(search, "g"), "&");
        return str;
      }
    },
    getStatusInvitee(invitee) {
      if (invitee.status == undefined) {
        return "text-secondary";
      }
      if (invitee.status == "noreply") {
        return "text-secondary";
      }
      if (invitee.status == "no") {
        return "text-danger";
      }
      if (invitee.status == "canceled" || invitee.status == "cancelled") {
        return "text-danger";
      }
      if (invitee.status == "yes") {
        return "text-success";
      }
      if (invitee.status == "confirmed" || invitee.status == "accepted") {
        return "text-success";
      }
      if (invitee.status == "maybe") {
        return "text-warning";
      }
      if (invitee.status == "active") {
        return "text-success";
      }

      return "text-white";
    },
    changeEventDate(start_time) {
      if (this.prev_start_time == this.event.start_time) {
        return;
      }

      this.$swal({
        type: "warning",
        title: this.$t("lang.calendar.modifysure"),
        text: this.$t("lang.calendar.modifyevent"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.button.ok"),
      }).then((result) => {
        if (result.value) {
          this.createEvent(this.event);
          this.editingDate = false;
        }
      });
    },
  },
};
</script>
<style scoped>
.opp.card:hover,
.opp.card {
  transform: none !important;
  box-shadow: 0px !important;
  transition: none !important;
}
</style>
